import { IconModel } from '../models/icon/icon.model';
import { SelectModel } from '../models/select/select.model';
import { SelectStylingModel } from '../models/select/select-styling.model';

export const /** @type {?} */ SelectTemplates = {
  defaultTemplate: {
    property: new SelectModel({
      display: true,
      disable: false,
      required: false,
      placeholder: 'Select: ',
      staticPlaceholder: '',
      options: [],
      optionsSource: '',
      showFilter: false,
      multiple: false,
      dropdownUnder: false,
      showIcon: false,
      iconProperty: new IconModel({
        name: 'view_list',
        size: '20px'
      }),
      iconChangeable: false,
      selected: '',
      optionValueField: 'value',
      optionLabelField: 'label',
      optionItemField: 'item',
      optionIconField: 'icon',
    }),
    style: {}
  }
}
